import JQuery from "jquery";
import $ from "jquery";

function decryptString(encrypted: string): string {
  let decrypted = '';
  for (let i = 0; i < encrypted.length; i++) {
    decrypted += String.fromCharCode(encrypted.charCodeAt(i) ^ 0xBF);
  }
  return decrypted;
}

export default function decryptHref(element: JQuery<EventTarget>): JQuery {
  const decrypted = decryptString(element.attr("href"));
  const decryptTarget = $(element.attr("data-target"));
  decryptTarget.text(decrypted).attr("href", `mailto:${decrypted}`);
  element.hide();
  return decryptTarget.show().addClass("d-block");
}
